// import store from '@/store/index.js'
// let dic = store.state.dic;

export default function Configs(that) {

    const searchItems = [
        {
            label: "身份证号",
            span: 5,
            placeholder: '请输入身份证号',
            model: "11",
        },
        {
            label: "姓名",
            span: 5,
            placeholder: '请输入姓名',
            model: "22",
            type: "select",
        },
        {
            label: "学号",
            prop: "studentNo",
            span: 5,
            placeholder: '请输入学号',
            model: "33",
        },
        {
            label: "报到状态",
            span: 5,
            placeholder: '请选择报到状态',
            model: "44",
            type:'select'
        },
        {
            label: "请假状态",
            span: 4,
            placeholder: '请选择请假状态',
            model: "55",
            type:'select'
        },
        {
            label: "学院",
            span: 5,
            placeholder: '请选择学院',
            model: "66",
            type: "select",
        },
        {
            label: "系别",
            span: 5,
            placeholder: '请选择系别',
            model: "77",
            type: "select",
        },
        {
            label: "专业",
            span: 5,
            placeholder: '请选择专业',
            model: "88",
            type: "select",
        },
        {
            label: "班级",
            span: 5,
            placeholder: '请选择班级',
            model: "99",
            type: "select",
        },
        {
            label: "备注",
            span: 4,
            placeholder: '请输入备注',
            model: "100",
        },
        
    ]
    const tableColumns = [
        {
            label: "到站时间",
            prop: "11",
            align: "center",
            show: true
        },
        {
            label: "预报到人数",
            prop: "22",
            align: "center",
            show:true
        },
        {
            label: "校迎新车辆",
            prop: "33",
            align: "center",
            show:true,
            children: [
                {
                    label: "厦门站",
                    prop: "studentName",
                    align: "center",
                    show: true,
                },
                {
                    label: "厦门北站",
                    prop: "studentName",
                    align: "center",
                    show: true,
                },
                {
                    label: "集美汽车站",
                    prop: "studentName",
                    align: "center",
                    show: true,
                },
            ]
        },
    ]

    return {
        searchItems,
        tableColumns
    }
}
